import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { Toaster } from 'sonner';
import ReactDOM from 'react-dom/client';
import Provider from 'utils/providers';
import { BrowserRouter } from 'react-router-dom';

import App from './App';

import './assets/styles/index.css';
import 'aos/dist/aos.css';

navigator.serviceWorker.register('/firebase-messaging-sw.js').then((reg) => {
  reg.update();
});

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      networkMode: 'offlineFirst',
      staleTime: 60 * 1000,
      cacheTime: 60 * 1000,
      refetchInterval: 60 * 1000,
    },
    mutations: {
      networkMode: 'offlineFirst',
    },
  },
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <QueryClientProvider client={queryClient}>
    <BrowserRouter>
      <Provider>
        <Toaster />
        <App />
      </Provider>
      <ReactQueryDevtools position="bottom-right" />
    </BrowserRouter>
  </QueryClientProvider>,
);
